export default "__VITE_ASSET__CYlbBkUx__"